export default __webpack_public_path__ + "assets/028ec2.svg";